import { getInstanceInfo, reportClientError } from '@postifoto/api-client';

/*
 * Ошибки интерфейса — в журнал ошибок через API (CP1a №2): сервер вырезает персональные данные
 * и пересылает их провайдеру. Своего SDK в браузере нет — стартовый бандл не растёт, CSP прежний.
 * Отправляется не больше 10 ошибок за загрузку страницы, одинаковые — один раз.
 */

const LIMIT = 10;
const sent = new Set<string>();
let enabled = false;

function report(error: unknown): void {
  if (!enabled || sent.size >= LIMIT) return;
  const value = error instanceof Error ? error : new Error(String(error));
  const key = `${value.name}:${value.message}`;
  if (sent.has(key)) return;
  sent.add(key);
  void reportClientError({
    name: value.name.slice(0, 200),
    message: value.message.slice(0, 2000),
    ...(value.stack ? { stack: value.stack.slice(0, 8000) } : {}),
    path: window.location.pathname.slice(0, 500),
  }).catch(() => undefined);
}

/** Ошибка отрисовки маршрута (router `defaultOnCatch`). */
export function reportRenderError(error: unknown): void {
  report(error);
}

/** Подписка после старта: журнал включён, только если он настроен на сервере. */
export function installErrorReporting(): void {
  window.addEventListener('error', (event) => report(event.error ?? event.message));
  window.addEventListener('unhandledrejection', (event) => report(event.reason));
  void getInstanceInfo()
    .then((info) => {
      enabled = info.features.errorReporting;
    })
    .catch(() => undefined);
}
